module.exports = __webpack_public_path__ + "img/background.c4061ad4.jpg";